/**
 * DetailPillNode — compact quantity pill for the provenance DAG.
 *
 * Shows only the key by default (~60x24). Expands to show `key: value`
 * on hover via CSS transition. Target handle on top only.
 */

import { memo, useState } from "react";
import { Handle, Position, type NodeProps } from "@xyflow/react";
import { DETAIL_PILL_WIDTH, DETAIL_PILL_HEIGHT } from "./dagNodeSizing";
import { CrispNodeContent } from "./CrispNodeContent";

export interface DetailPillData {
  detailKey: string;
  detailValue: string;
  [key: string]: unknown;
}

function DetailPillNodeInner({ data }: NodeProps) {
  const { detailKey, detailValue } = data as unknown as DetailPillData;
  const [hovered, setHovered] = useState(false);

  return (
    <>
      <Handle type="target" position={Position.Top} style={{ opacity: 0 }} />
      <CrispNodeContent width={DETAIL_PILL_WIDTH} height={DETAIL_PILL_HEIGHT} style={{ overflow: "visible" }}>
        <div
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
          style={{
            background: "rgba(148,163,184,0.18)",
            borderRadius: 12,
            padding: "3px 10px",
            fontSize: 10,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: hovered ? 260 : 80,
            transition: "max-width 0.15s ease-out",
            cursor: "default",
            lineHeight: "18px",
            color: "inherit",
          }}
        >
          <span style={{ fontWeight: 600 }}>{detailKey}</span>
          {hovered && (
            <span style={{ fontWeight: 400 }}>: {detailValue}</span>
          )}
        </div>
      </CrispNodeContent>
    </>
  );
}

export const DetailPillNode = memo(DetailPillNodeInner);
